import ToastContainer from './ToastContainer';
import mitt from 'mitt';

export const createToastGlobal = (Vue, globalOptions = {}) => {
    const emitter = mitt();

    Vue.prototype.$toastEmitter = emitter;

    if (!globalOptions.useToastContainer) {
        const ToastContainerClone = Vue.extend(ToastContainer);

        const vm = new ToastContainerClone().$mount();

        document.body.appendChild(vm.$el);
    }

    return (options) => {
        emitter.emit('open', options);
    };
};
